export const SUPPORT_EMAIL = 'care.netlify.app@gmail.com';
export const APP_NAME = 'Care';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.cyberviper.care';
export const APP_STORE_URL = 'https://apps.apple.com/us/app/care-medtrak/id6759403151';
